import { FC, useState, useEffect } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useStore, connect } from "src/store/connect";
import Item from "../Item";
import { Typography, Button } from "@material-ui/core";

interface BackgroundCheckFormProps {
  targetBlock: Block;
  onChangeBackgroundCheckInput: (newBackgroundCheckInput: CheckInput) => void;
}

const BackgroundCheckForm: FC<BackgroundCheckFormProps> = ({
  targetBlock,
  onChangeBackgroundCheckInput,
}) => {
  const classes = useStyles();
  const state = useStore();
  const emptyBackgroundCheckForm: CheckInput = {
    firstName: {
      variableID: "",
      default: "",
    },
    lastName: {
      variableID: "",
      default: "",
    },
    nationalId: {
      variableID: "",
      default: "",
    },
    country: {
      variableID: "",
      default: "",
    },
    type: {
      variableID: "",
      default: "",
    },
    userAuthorized: {
      variableID: "",
      default: "",
    },
  };
  const [backgroundCheckForm, setBackgroundCheckForm] = useState<CheckInput>(
    targetBlock.data.backgroundCheckInput || (() => emptyBackgroundCheckForm)
  );

  const [prevDefinedVariables, setPrevDefinedVariables] = useState<string[]>(
    []
  );

  useEffect(() => {
    const variables = state.getPrevDefinedVariables(targetBlock.id);
    if (!variables || variables.length === 0) {
      return;
    }

    setPrevDefinedVariables((variables as string[]) || []);
  }, [state.flow, state.flow.edges, state.flow.nodes]);

  const onChangeFirstName = (backgroundCheckVariable: FormInputVariable) => {
    const newCheckInput: CheckInput = {
      ...backgroundCheckForm,
      firstName: backgroundCheckVariable,
    };
    setBackgroundCheckForm(newCheckInput);
  };

  const onChangeLastName = (backgroundCheckVariable: FormInputVariable) => {
    const newCheckInput: CheckInput = {
      ...backgroundCheckForm,
      lastName: backgroundCheckVariable,
    };
    setBackgroundCheckForm(newCheckInput);
  };

  const onChangeNationalId = (backgroundCheckVariable: FormInputVariable) => {
    const newCheckInput: CheckInput = {
      ...backgroundCheckForm,
      nationalId: backgroundCheckVariable,
    };
    setBackgroundCheckForm(newCheckInput);
  };

  const onChangeCountry = (backgroundCheckVariable: FormInputVariable) => {
    const newCheckInput: CheckInput = {
      ...backgroundCheckForm,
      country: backgroundCheckVariable,
    };
    setBackgroundCheckForm(newCheckInput);
  };

  const commitBackgroundCheckInput = () => {
    // const variables = state.getPrevDefinedVariables(targetBlock.id)
    // if (!variables || variables.length === 0) {
    //   return
    // }

    onChangeBackgroundCheckInput(backgroundCheckForm);
  };

  return (
    <div>
      <Item
        fieldName="Nombre"
        placeholder="p. ej. Andrés"
        initialValue={backgroundCheckForm.firstName}
        required={true}
        variables={prevDefinedVariables}
        onChange={onChangeFirstName}
      ></Item>

      <Item
        fieldName="Apellidos"
        placeholder="p. ej. Muñoz"
        initialValue={backgroundCheckForm.lastName}
        required={true}
        variables={prevDefinedVariables}
        onChange={onChangeLastName}
      ></Item>

      <Item
        fieldName="ID"
        placeholder="p. ej. PEER193891391"
        initialValue={backgroundCheckForm.nationalId}
        required={true}
        variables={prevDefinedVariables}
        onChange={onChangeNationalId}
      ></Item>

      <Item
        fieldName="País"
        placeholder="p. ej. MX"
        initialValue={backgroundCheckForm.country}
        required={true}
        variables={prevDefinedVariables}
        onChange={onChangeCountry}
      ></Item>

      {/* TODO: ask for check input "type". */}

      <Button
        variant="contained"
        color="primary"
        className={classes.commitChangesButton}
        onClick={commitBackgroundCheckInput}
      >
        Guardar
      </Button>
    </div>
  );
};

BackgroundCheckForm.defaultProps = {};

export default connect(BackgroundCheckForm);

const useStyles = makeStyles((theme: Theme) => ({
  commitChangesButton: {
    textTransform: "none",
    position: "absolute",
    right: "0.75rem",
    bottom: "0.75rem",
    padding: "0.25rem 1.5rem",
    borderRadius: "8px",
  },
}));
